// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"214":"c28e7ff0","453":"92a4c1fc"}[chunkId] + ".chunk.js";
};